import classes from "./ClickableLink.module.scss";

export interface ClickableLinkProps {
  text: string;
  onClick: () => void;
}

export function ClickableLink({ text, onClick }: ClickableLinkProps) {
  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <span
      className={classes["clickable-link"]}
      onClick={onClick}
      role="button"
      style={{
        textDecoration: "underline",
      }}
    >
      {text}
    </span>
  );
}
